/* ============================================================
   Shopify Forms アプリ：入力済みラベル非表示
   Shadow DOM 内に style を注入する方式。
   サードパーティフォームアプリに切り替える際はこのブロックを削除。
   ============================================================ */
(function () {
  function injectFormLabelStyle(embed) {
    if (!embed.shadowRoot) return;
    if (embed.shadowRoot.querySelector('#custom-label-hide')) return;
    var style = document.createElement('style');
    style.id = 'custom-label-hide';
    style.textContent =
      '[class*="inputFilled"][class*="formInputFieldLabel"] {' +
      '  transform: scale(0.75) translateY(-16px) !important;' +
      '  opacity: 0.6 !important;' +
      '  transition: transform 0.2s ease, opacity 0.2s ease !important;' +
      '}';
    embed.shadowRoot.appendChild(style);
  }

  function applyToAllForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(injectFormLabelStyle);
  }

  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-forms-embed').then(function () {
      applyToAllForms();
      // 動的に追加される embed 要素にも対応
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.tagName === 'SHOPIFY-FORMS-EMBED') {
              injectFormLabelStyle(node);
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    document.addEventListener('DOMContentLoaded', applyToAllForms);
  }
})();
/* ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('header-component.header') || document.querySelector('header');
  if (!header) return;

  // 透明ヘッダーがテーマ標準でサポートされているテンプレート
  var transparentSupportedTemplates = ['index', 'product', 'collection'];
  var main = document.querySelector('main[data-template]');
  var currentTemplate = main ? main.getAttribute('data-template') : '';
  // "product.biz" のようなsuffixも考慮してtemplate名のみ取得
  var templateName = currentTemplate.split('.')[0];
  var isBizPage = document.body.classList.contains('is-biz');
  var isTransparentSupported = transparentSupportedTemplates.indexOf(templateName) !== -1 || isBizPage;

  function updateHeader() {
    // 透明非対応ページ、または短いページ、またはスクロール済みならglassy
    var pageHeight = document.documentElement.scrollHeight;
    var viewHeight = window.innerHeight;
    var isShortPage = pageHeight < viewHeight * 1.5;

    if (!isTransparentSupported || (!isBizPage && isShortPage) || window.scrollY > 50) {
      header.classList.add('is-glassy');
    } else {
      header.classList.remove('is-glassy');
    }
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
});

// toCヘッダーのみ1340px以下でハンバーガーに強制切り替え
// theme.liquidのsetHeaderMenuStyle()より後に実行されるよう、
// #header-componentの出現とdata-menu-styleの変化をMutationObserverで監視する
(function () {
  function getCorrectMenuStyle() {
    var isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
    return (window.innerWidth <= 1340 || isTouchDevice) ? 'drawer' : 'menu';
  }

  function watchHeaderComponent(headerComponent) {
    // data-menu-styleを監視して上書きを防ぐ
    var attrObserver = new MutationObserver(function () {
      var correct = getCorrectMenuStyle();
      if (headerComponent.dataset.menuStyle !== correct) {
        headerComponent.dataset.menuStyle = correct;
      }
    });
    attrObserver.observe(headerComponent, { attributes: true, attributeFilter: ['data-menu-style'] });

    // 初回適用
    headerComponent.dataset.menuStyle = getCorrectMenuStyle();

    // リサイズ対応
    window.addEventListener('resize', function () {
      headerComponent.dataset.menuStyle = getCorrectMenuStyle();
    }, { passive: true });
  }

  function init() {
    // bizページはスキップ
    if (document.body.classList.contains('is-biz')) return;

    var headerComponent = document.querySelector('#header-component');
    if (headerComponent) {
      watchHeaderComponent(headerComponent);
      return;
    }

    // まだDOMにない場合はMutationObserverで待つ
    var domObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.id === 'header-component' || (node.querySelector && node.querySelector('#header-component'))) {
            var el = node.id === 'header-component' ? node : node.querySelector('#header-component');
            domObserver.disconnect();
            watchHeaderComponent(el);
            return;
          }
        }
      }
    });
    domObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  // DOMContentLoaded後に実行（bodyのis-bizクラスが確定してから）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
